import { TextArea, NewTextArea } from '@carta/ink';
import * as React from 'react';
export default {
  TextArea,
  NewTextArea,
  React
};